import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {translate} from 'admin-on-rest';
import shouldUpdate from 'recompose/shouldUpdate';
import compose from 'recompose/compose';
import ImageEye from 'material-ui/svg-icons/image/remove-red-eye';
import IconButton from 'material-ui/IconButton';
import linkToRecord from './linkToRecord';
import {cyan500} from 'material-ui/styles/colors';


const ShowButton = ({
    basePath = '',
    label = 'aor.action.show',
    record = {},
    translate,
}) => (
    <IconButton
      iconStyle={{color:cyan500}}
      containerElement={<Link to={`${linkToRecord(basePath, record.id)}/show`} />}
    >
      <ImageEye/>
    </IconButton>
);

ShowButton.propTypes = {
    basePath: PropTypes.string,
    label: PropTypes.string,
    record: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    shouldUpdate(
        (props, nextProps) =>
            (props.record &&
                nextProps.record &&
                props.record.id !== nextProps.record.id) ||
            props.basePath !== nextProps.basePath ||
            (props.record == null && nextProps.record != null)
    ),
    translate
);

export default enhance(ShowButton);


// WEBPACK FOOTER //
// ./src/components/button/ShowButton.js